import api from '../config/api';

const ESTILOS_VALIDOS = ['colorido', 'estandar', 'azul_oro'];

export function normalizarEstiloBoletaConfig(estilo, boletaEstandar = false) {
  const e = String(estilo || '').toLowerCase().trim();
  if (ESTILOS_VALIDOS.includes(e)) return e;
  return boletaEstandar ? 'estandar' : 'colorido';
}

const configuracionBoletaService = {
  async obtenerConfiguracion(empresaId) {
    try {
      const response = await api.get(`/configuracion-boleta/empresa/${empresaId}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al obtener configuración de boleta',
      };
    }
  },

  /**
   * @param {number} empresaId
   * @param {string|boolean} estiloOEstandar - estilo ('colorido'|'estandar'|'azul_oro') o boolean legacy
   */
  async actualizarConfiguracion(empresaId, estiloOEstandar) {
    try {
      let payload;
      if (typeof estiloOEstandar === 'boolean') {
        payload = { boleta_estandar: estiloOEstandar };
      } else {
        payload = {
          estilo_boleta: normalizarEstiloBoletaConfig(estiloOEstandar),
        };
      }
      const response = await api.put(`/configuracion-boleta/empresa/${empresaId}`, payload);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      if (error.response?.status === 422) {
        return {
          success: false,
          error: 'Datos de entrada inválidos',
          details: error.response.data.details,
        };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al actualizar configuración de boleta',
      };
    }
  },

  async verificarEstado(empresaId) {
    try {
      const response = await api.get(`/configuracion-boleta/empresa/${empresaId}/estado`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, error: 'Empresa no encontrada' };
      }
      return {
        success: false,
        error: error.response?.data?.error || 'Error al verificar estado de boleta',
      };
    }
  },
};

export default configuracionBoletaService;
